module.exports = __webpack_public_path__ + "static/9-bc986cb2a0ca3db1d10a7c9de6ff759c.jpeg";